module.exports = __webpack_public_path__ + "img/up-to-line.e4310860.svg";